import client from './client';

export interface PollOption {
  id?: number;
  text_kk: string;
  text_ru: string;
  vote_count?: number;
  percentage?: number;
}

export interface Poll {
  id: number;
  title_kk: string;
  title_ru: string;
  description_kk?: string;
  description_ru?: string;
  poll_type: 'single' | 'multiple';
  target_district?: string;
  start_date?: string;
  end_date?: string;
  is_active: boolean;
  is_implemented: boolean;
  total_votes: number;
  unique_voters: number;
  options_count: number;
  created_at: string;
}

export interface PollCreatePayload {
  title_kk: string;
  title_ru: string;
  description_kk?: string;
  description_ru?: string;
  poll_type: 'single' | 'multiple';
  target_district?: string;
  start_date?: string;
  end_date?: string;
  options: { text_kk: string; text_ru: string }[];
}

export interface PollUpdatePayload {
  title_kk?: string;
  title_ru?: string;
  description_kk?: string;
  description_ru?: string;
  is_active?: boolean;
  end_date?: string;
}

export interface PollStats {
  poll_id: number;
  title_ru: string;
  total_votes: number;
  unique_voters: number;
  options: PollOption[];
  daily_votes: { date: string; count: number }[];
}

export const pollsApi = {
  list: (params?: { is_active?: boolean }) =>
    client.get<Poll[]>('/api/admin/polls/', { params }),

  create: (data: PollCreatePayload) =>
    client.post('/api/admin/polls/', data),

  update: (id: number, data: PollUpdatePayload) =>
    client.patch(`/api/admin/polls/${id}`, data),

  delete: (id: number) =>
    client.delete(`/api/admin/polls/${id}`),

  stats: (id: number) =>
    client.get<PollStats>(`/api/admin/polls/${id}/stats`),

  notify: (id: number) =>
    client.post(`/api/admin/polls/${id}/notify`),
};
